import React from 'react';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import {
  OrganizationSelect,
  ProjectSelect,
  ReactFormInput,
  ReactFormSelect,
  SceneSelect,
  UserSelect,
  VideoSelect,
} from '../../components';
import SavedSearchService, { SavedSearchPages } from '../../services/SavedSearchService';
import { useGuard } from '../../hooks';
import { is, roles } from '../../utility/guard';
import { selectLists } from '../../store/modules/lists/selectors';

type Props = {
  creatingMode?: boolean;
};

const OrderFields = ({ creatingMode }: Props) => {
  const isSuperAdmin = useGuard(is(roles.superAdmin));
  const lists = useSelector(selectLists);

  const typesList = (lists && lists.data) ? lists?.data['order-type'].map((item) => ({
    title: item.value,
    id: item.key,
  })) : [];

  const statusesList = (lists && lists.data) ? lists?.data['order-status'].map((item) => ({
    title: item.value,
    id: item.key,
  })) : [];

  const { watch } = useFormContext();
  const userId = watch('user_id');
  const projectId = watch('project_id');

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Grid item xs={12} lg={6}>
          <ReactFormInput
            label="Title"
            name="title"
            autoFocus
            getValueAfterInit={() => SavedSearchService.getValue(SavedSearchPages.Orders)}
            disabled={!creatingMode}
            spellCheck
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <UserSelect
          label="User"
          name="user_id"
          formType="react"
          firstCallFilters={userId > 0 ? [{ key: 'user_id', value: userId }] : []}
          disabled={!creatingMode}
        />
      </Grid>
      <Grid item xs={12} sm={6} />
      <Grid item xs={12} sm={6}>
        <ReactFormSelect
          items={statusesList}
          label="Status"
          name="status_id"
          disabled={!isSuperAdmin}
          isNone={!(statusesList && statusesList.length)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ReactFormSelect
          items={typesList}
          label="Type"
          name="type_id"
          disabled={!creatingMode}
          isNone={!(statusesList && statusesList.length)}
        />
      </Grid>
      <Grid item xs={12} lg={12}>
        <ReactFormInput
          label="Notes"
          name="notes"
          type="textarea"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <OrganizationSelect
          label="Organization"
          name="organization_id"
          disabled={!creatingMode}
          formType="react"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <VideoSelect
          label="Video"
          name="video_id"
          disabled={!creatingMode || userId < 1}
          filters={[{ key: 'user_id', value: userId }]}
          dependentFieldName="user_id"
          formType="react"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ProjectSelect
          label="Project"
          name="project_id"
          disabled={!creatingMode || userId < 1}
          filters={[{ key: 'user_owner_id', value: userId }]}
          firstCallFilters={[{ key: 'id', value: projectId }]}
          dependentFieldName="user_id"
          formType="react"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SceneSelect
          label="Scene"
          name="scene_id"
          disabled={!creatingMode || projectId < 1}
          filters={[{ key: 'project_id', value: projectId }]}
          dependentFieldName="project_id"
          formType="react"
        />
      </Grid>
      {isSuperAdmin && (
        <Grid item xs={12} sm={6}>
          <ReactFormInput
            label="Invoice#"
            name="invoice_id"
            disabled={!creatingMode}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default OrderFields;
